/**
 * 白名单（KYC 已通过的活跃用户）— UsersListPage 的一个预设过滤视图。
 */
import { UsersListPage } from './UsersListPage';

export function WhitelistPage() {
  return <UsersListPage pageTitle="白名单" initialStatus="active" initialKycStatus="approved" />;
}
